import { BookmarkCheckOutlineIcon } from './BookmarkCheckOutlineIcon';

/**
 * author: Simran
 * id EFBBDF1F-1497-4BA3-AE93-614B2BB496F7
 * name bookmark-check-outline
 * version: 4.9.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/bookmark-check-outline.svg
 * tags
 */
export const BookmarkSuccessOutlineIcon = BookmarkCheckOutlineIcon;
export default BookmarkSuccessOutlineIcon